import { lazy } from "react";
import type { RouteConfig } from "../config";
import { ROUTES } from "../paths";

const EnergiaDashboardPage = lazy(() =>
  import("@/pages/energia/energia-dashboard-page").then((m) => ({ default: m.EnergiaDashboardPage }))
);
const EnergiaIndicadorDetailPage = lazy(() =>
  import("@/pages/energia/energia-indicador-detail-page").then((m) => ({ default: m.EnergiaIndicadorDetailPage }))
);
const EnergiaIndicadorNewPage = lazy(() =>
  import("@/pages/energia/energia-indicador-new-page").then((m) => ({ default: m.EnergiaIndicadorNewPage }))
);
const EnergiaMapaPage = lazy(() =>
  import("@/pages/energia/energia-mapa-page").then((m) => ({ default: m.EnergiaMapaPage }))
);
const EnergiaIndicadoresPage = lazy(() =>
  import("@/pages/energia/energia-indicadores-page").then((m) => ({ default: m.EnergiaIndicadoresPage }))
);
const EnergiaMonitorizacaoPage = lazy(() =>
  import("@/pages/energia/energia-monitorizacao-page").then((m) => ({ default: m.EnergiaMonitorizacaoPage }))
);
const EnergiaEletricaPage = lazy(() =>
  import("@/pages/energia/energia-eletrica-page").then((m) => ({ default: m.EnergiaEletricaPage }))
);
const EnergiaAguaPage = lazy(() =>
  import("@/pages/energia/energia-agua-page").then((m) => ({ default: m.EnergiaAguaPage }))
);
const EnergiaGasPage = lazy(() =>
  import("@/pages/energia/energia-gas-page").then((m) => ({ default: m.EnergiaGasPage }))
);
const EnergiaCombustiveisPage = lazy(() =>
  import("@/pages/energia/energia-combustiveis-page").then((m) => ({ default: m.EnergiaCombustiveisPage }))
);
const EnergiaResiduosPage = lazy(() =>
  import("@/pages/energia/energia-residuos-page").then((m) => ({ default: m.EnergiaResiduosPage }))
);
const EnergiaAmbientePage = lazy(() =>
  import("@/pages/energia/energia-ambiente-page").then((m) => ({ default: m.EnergiaAmbientePage }))
);
const MelhoriaPage = lazy(() =>
  import("@/pages/energia/melhoria-page").then((m) => ({ default: m.MelhoriaPage }))
);
const FontesInfoPage = lazy(() =>
  import("@/pages/energia/fontes-info-page").then((m) => ({ default: m.FontesInfoPage }))
);
const EnergiaBscAdminPage = lazy(() =>
  import("@/pages/energia/energia-bsc-admin-page").then((m) => ({ default: m.EnergiaBscAdminPage }))
);

const ENERGIA_READ   = { access: "permission" as const, entity: "energia", action: "READ" };
const ENERGIA_UPDATE = { access: "permission" as const, entity: "energia", action: "UPDATE" };
const ENERGIA_CREATE = { access: "permission" as const, entity: "energia", action: "CREATE" };

export const energiaRoutes: RouteConfig[] = [
  { path: ROUTES.ENERGIA.DASHBOARD,        component: EnergiaDashboardPage,       layout: "dashboard", permissions: ENERGIA_READ },
  { path: ROUTES.ENERGIA.MAPA,             component: EnergiaMapaPage,            layout: "dashboard", permissions: ENERGIA_READ },
  { path: ROUTES.ENERGIA.INDICADORES,      component: EnergiaIndicadoresPage,     layout: "dashboard", permissions: ENERGIA_READ },
  { path: ROUTES.ENERGIA.INDICADOR_NEW,    component: EnergiaIndicadorNewPage,    layout: "dashboard", permissions: ENERGIA_CREATE },
  { path: ROUTES.ENERGIA.INDICADOR_DETAIL, component: EnergiaIndicadorDetailPage, layout: "dashboard", permissions: ENERGIA_READ },
  { path: ROUTES.ENERGIA.MONITORIZACAO,    component: EnergiaMonitorizacaoPage,   layout: "dashboard", permissions: ENERGIA_READ },
  { path: ROUTES.ENERGIA.ENERGIA_ELETRICA, component: EnergiaEletricaPage,        layout: "dashboard", permissions: ENERGIA_READ },
  { path: ROUTES.ENERGIA.AGUA,             component: EnergiaAguaPage,            layout: "dashboard", permissions: ENERGIA_READ },
  { path: ROUTES.ENERGIA.GAS,              component: EnergiaGasPage,             layout: "dashboard", permissions: ENERGIA_READ },
  { path: ROUTES.ENERGIA.COMBUSTIVEIS,     component: EnergiaCombustiveisPage,    layout: "dashboard", permissions: ENERGIA_READ },
  { path: ROUTES.ENERGIA.RESIDUOS,         component: EnergiaResiduosPage,        layout: "dashboard", permissions: ENERGIA_READ },
  { path: ROUTES.ENERGIA.AMBIENTE,         component: EnergiaAmbientePage,        layout: "dashboard", permissions: ENERGIA_READ },
  { path: ROUTES.ENERGIA.MELHORIA,         component: MelhoriaPage,               layout: "dashboard", permissions: ENERGIA_READ },
  { path: ROUTES.ENERGIA.FONTES_INFO,      component: FontesInfoPage,             layout: "dashboard", permissions: ENERGIA_READ },
  { path: ROUTES.ENERGIA.BSC_ADMIN,        component: EnergiaBscAdminPage,        layout: "dashboard", permissions: ENERGIA_UPDATE },
];
